'use client';

import { __assign, __awaiter, __generator } from '../_virtual/_tslib.js';
import React__default, { useState, useEffect } from 'react';
import AIReviewBlock from './AIPreviewBlock/index.js';
import AiIcon from '../Images/AiIcon/index.js';
import { AIBannerContainer, TextAI, BlockAI, AIBannerButton } from './AIBanner.css.js';
import '../Images/AddIcon/index.js';
import '../Images/AddOutlinedIcon/index.js';
import '../Images/Trash/index.js';
import '../Images/Pencil/index.js';
import '../Images/ArrowRoundedLeft/index.js';
import '../Images/ArrowRoundedRight/index.js';
import '../Images/AwardsIcon/index.js';
import '../Images/BonusIcon/index.js';
import '../Images/CanteenIcon/index.js';
import '../Images/CheckTagIcon/index.js';
import '../Images/CommercialIcon/index.js';
import '../Images/CompanySizeIcon/index.js';
import '../Images/ContactIcon/index.js';
import '../Images/CopyIcon/index.js';
import '../Images/DefaultAvatar/index.js';
import '../Images/DangerIcon/index.js';
import '../Images/ExternalLinkIcon/index.js';
import '../Images/FacebookIcon/index.js';
import '../Images/ForwardIcon/index.js';
import '../Images/HealthcarePlanIcon/index.js';
import '../Images/HeartIcon/index.js';
import '../Images/HeartOutlineIcon/index.js';
import '../Images/HideIcon/index.js';
import '../Images/KindergartenIcon/index.js';
import '../Images/LaptopIcon/index.js';
import '../Images/LibraryIcon/index.js';
import '../Images/LinkIcon/index.js';
import '../Images/LinkedInIcon/index.js';
import '../Images/LoadingCircleIcon/index.js';
import '../Images/MarkerIcon/index.js';
import '../Images/MobileIcon/index.js';
import '../Images/PaidLeaveIcon/index.js';
import { ELanguage } from '../Utils/constants.js';
import '../Images/SearchIcon/index.js';
import '../Images/ShareIcon/index.js';
import '../Images/ReportIcon/index.js';
import '../Images/StatsIcon/index.js';
import '../Images/TeamActivitiesIcon/index.js';
import '../Images/ThreeDotIcon/index.js';
import '../Images/TrainingIcon/index.js';
import '../Images/TransportationIcon/index.js';
import '../Images/TrashIcon/index.js';
import '../Images/TravelOpportunitiesIcon/index.js';
import '../Colors/index.js';
import '../Images/VerticalMoreIcon/index.js';
import '../Images/VoucherIcon/index.js';
import '../Images/WowCVIcon/index.js';
import '../Images/WorkingLocationIcon/index.js';
import '../Images/ZaloIcon/index.js';
import '../Images/FacebookLogoIcon/index.js';
import '../Images/GoogleLogoIcon/index.js';
import '../Images/DragReorderIcon/index.js';
import '../Images/CheckIcon/index.js';
import '../Images/CircleChecked/index.js';
import '../Images/SalaryIcon/index.js';
import '../Images/BriefcaseIcon/index.js';
import '../Images/GraduationCapIcon/index.js';
import '../Images/EnvelopeIcon/index.js';
import '../Images/AddFilledIcon/index.js';
import '../Images/HomeIcon/index.js';
import '../Images/PhoneIcon/index.js';
import '../Images/AttachIcon/index.js';
import '../Images/FilterIcon/index.js';
import '../icons/WarnIcon.js';
import '../icons/AccountSettingsIcon.js';
import '../icons/DashboardIcon.js';
import '../icons/JobAlertsIcon.js';
import '../icons/MyCompaniesIcon.js';
import '../icons/MyJobsIcon.js';
import '../icons/MyProfileIcon.js';
import '../icons/ProfileSettingsIcon.js';
import '../icons/LanguageIcon.js';
import '../icons/BenefitGroupIcons/ActivityIcon.js';
import '../icons/BenefitGroupIcons/AwardsIcon.js';
import '../icons/BenefitGroupIcons/BonusIcon.js';
import '../icons/BenefitGroupIcons/CanteenIcon.js';
import '../icons/BenefitGroupIcons/HealthcareIcon.js';
import '../icons/BenefitGroupIcons/KindergartenIcon.js';
import '../icons/BenefitGroupIcons/LaptopIcon.js';
import '../icons/BenefitGroupIcons/LibraryIcon.js';
import '../icons/BenefitGroupIcons/MoreIcon.js';
import '../icons/BenefitGroupIcons/PaidLeaveIcon.js';
import '../icons/BenefitGroupIcons/PhoneIcon.js';
import '../icons/BenefitGroupIcons/TrainingIcon.js';
import '../icons/BenefitGroupIcons/TransportationIcon.js';
import '../icons/BenefitGroupIcons/TravelIcon.js';
import '../icons/BenefitGroupIcons/VoucherIcon.js';
import '../icons/BenefitGroupIcons/Physics.js';
import '../icons/BenefitGroupIcons/WorkingHourIcon.js';
import '../icons/BenefitGroupIcons/WorkingDayIcon.js';
import '../icons/BenefitGroupIcons/WorkingTypeIcon.js';
import '../icons/AccountCenterGroupIcons/ChartVertical.js';
import '../icons/AccountCenterGroupIcons/Language.js';
import '../icons/AccountCenterGroupIcons/EmptyHotCategory.js';
import '../icons/AccountCenterGroupIcons/Lawyer.js';
import '../icons/InfoOverviewGroupIcons/CompanySize.js';
import '../icons/InfoOverviewGroupIcons/Location.js';
import '../icons/InfoOverviewGroupIcons/Education.js';
import '../icons/InfoOverviewGroupIcons/PhoneNumber.js';
import '../icons/InfoOverviewGroupIcons/CalendarIOS16Glyph.js';
import '../icons/InfoOverviewGroupIcons/Admin.js';
import '../icons/InfoOverviewGroupIcons/HeadHunter.js';
import '../icons/InfoOverviewGroupIcons/Address.js';
import '../icons/InfoOverviewGroupIcons/Salary.js';
import '../icons/InfoOverviewGroupIcons/Gender.js';
import '../icons/InfoOverviewGroupIcons/Translator.js';
import '../icons/InfoOverviewGroupIcons/Birthday.js';
import '../icons/InfoOverviewGroupIcons/LocationIOS16Glyph.js';
import '../icons/InfoOverviewGroupIcons/CreditIcon.js';
import '../icons/MiscGroupIcons/Link.js';
import '../icons/MiscGroupIcons/History.js';
import '../icons/MiscGroupIcons/Favorite.js';
import '../icons/MiscGroupIcons/UnFavorite.js';
import '../icons/MiscGroupIcons/ProductDocuments.js';
import '../icons/MiscGroupIcons/Star.js';
import '../icons/SocialMediaGroupIcons/Facebook.js';
import '../icons/SocialMediaGroupIcons/Linkedin.js';
import '../icons/SocialMediaGroupIcons/Twitter.js';
import '../icons/SocialMediaGroupIcons/Zalo.js';
import '../icons/SocialMediaGroupIcons/FacebooksColorFull.js';
import '../icons/SocialMediaGroupIcons/LinkedinColorFull.js';
import '../icons/SocialMediaGroupIcons/TwitterColorFull.js';
import '../icons/SocialMediaGroupIcons/ZaloColorFull.js';
import '../icons/SocialMediaGroupIcons/Share.js';
import '../icons/NavigationGroupIcons/Vertical.js';
import '../icons/NavigationGroupIcons/More.js';
import '../icons/NavigationGroupIcons/Close.js';
import '../icons/NavigationGroupIcons/Expand.js';
import '../icons/NavigationGroupIcons/Collapse.js';
import '../icons/NavigationGroupIcons/Next.js';
import '../icons/NavigationGroupIcons/Back.js';
import '../icons/NavigationGroupIcons/ExternalLink.js';
import '../icons/NavigationGroupIcons/RightArrow.js';
import '../icons/AlertGroupIcons/SuccessIcon.js';
import '../icons/AlertGroupIcons/CareerPath.js';
import '../icons/AlertGroupIcons/Hot.js';
import '../icons/AlertGroupIcons/Urgent.js';
import '../icons/FormActionGroupIcons/Exchange.js';
import '../icons/FormActionGroupIcons/AddTag.js';
import '../icons/RewardsTypeGroupIcons/Hospital.js';
import '../Images/DoubleTickIcon/index.js';
import '../Images/BellIcon/index.js';
import CircleArrowRightIcon from '../Images/CircleArrowRightIcon/index.js';
import MiniAiIcon from '../Images/MiniAiIcon/index.js';
import '../icons/OrderManagementIcon.js';
import '../Images/TwinkleLinearGradientIcon/index.js';
import translations from './translations.js';
import { getCVReviews, getAITrial } from './services.js';

var AIBanner = function (props) {
    var user = props.user, jobId = props.jobId, _a = props.type, type = _a === void 0 ? 'text' : _a, env = props.env, langCode = props.langCode, text = props.text;
    var baseMsUrl = env.baseMsUrl;
    var _b = useState([]), cvReviews = _b[0], setCvReviews = _b[1];
    var _c = useState(null), cvReviewTrial = _c[0], setCvReviewTrial = _c[1];
    var _d = useState(false), showBanner = _d[0], setShowBanner = _d[1];
    var t = function (key) {
        if (langCode === ELanguage.EN) {
            return key;
        }
        else {
            return translations[key] || key;
        }
    };
    var getReviewTrial = function () { return __awaiter(void 0, void 0, void 0, function () {
        var cvReviewPromise, cvReviewTrialPromise, response;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    cvReviewPromise = getCVReviews(jobId, (_a = user === null || user === void 0 ? void 0 : user.accessToken) !== null && _a !== void 0 ? _a : '', baseMsUrl);
                    cvReviewTrialPromise = getAITrial({
                        accessToken: String(user === null || user === void 0 ? void 0 : user.accessToken),
                        baseMsUrl: baseMsUrl
                    });
                    return [4 /*yield*/, Promise.allSettled([cvReviewPromise, cvReviewTrialPromise])
                        // Get CV Reviews
                    ];
                case 1:
                    response = _b.sent();
                    // Get CV Reviews
                    setCvReviews(response[0].status === 'fulfilled' ? response[0].value : []);
                    // Get AI CV Review trial
                    setCvReviewTrial(response[1].status === 'fulfilled' ? response[1].value : null);
                    return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        getReviewTrial();
    }, []);
    return (React__default.createElement(AIBannerContainer, null,
        type === 'text' && (React__default.createElement(TextAI.Container, null,
            React__default.createElement(AiIcon, { width: 20 }),
            React__default.createElement(TextAI.Content, { onClick: function () { return setShowBanner(true); } }, text || t('View competitive analysis')))),
        type === 'block' && (React__default.createElement(BlockAI.Container, { onClick: function () { return setShowBanner(true); } },
            React__default.createElement(BlockAI.Left, null,
                React__default.createElement(BlockAI.Title, null, t('Competitive Analysis')),
                React__default.createElement(BlockAI.BlockAIText, null,
                    React__default.createElement(MiniAiIcon, null),
                    " VietnamWorks AI")),
            React__default.createElement(BlockAI.Right, null,
                React__default.createElement(AIBannerButton, null,
                    t('View analysis'),
                    React__default.createElement(CircleArrowRightIcon, { width: 24 })),
                React__default.createElement(AiIcon, { width: 58, type: 'secondary' })))),
        React__default.createElement(AIReviewBlock, __assign({ cvReviews: cvReviews, cvReviewTrial: cvReviewTrial, t: t, showBannerState: [showBanner, setShowBanner] }, props))));
};

export { AIBanner as default };
//# sourceMappingURL=index.js.map
